import React from 'react'

import { withRouter } from 'react-redux'
import * as actions from '../../actions'
import styled from 'styled-components'
import ReactResizeDetector from 'react-resize-detector'
import momentDurationFormat from 'moment-duration-format'

const Wrap = styled.div`
  width: 100%;
  display: flex;
  left: -15px;
  width: calc(100% + 30px);
`

const ColumnTableWrap = styled.div`
  flex-grow: 1;
  margin: 16px;
  min-width: 300px;
  width: 100%;
`

const ColumnTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  color: #f2f2f2;
`
const totalMinWidthOfColumnTable = 16 + 16 + 300

const TableHead = styled.thead`

  opacity: 0.4;

  tr {
    height: 23px;
    padding: 0px 32px;
  }
`

const TableHeading = styled.th`
  ${props => props.width && `
    width: ${props.width}px;
  `}

  ${props => props.side && props.padding && `

    ${(props.side === 'left') ? `
      padding: 0 0 0 ${props.padding}px;
      text-align: left;
    ` : `
      padding: 0 ${props.padding}px 0 0;
      text-align: right;
    `}}
  `}

  font-family: 'Source Sans Pro';
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;

  ${props => props.separators && `
    border-bottom: 1px solid #4d4d4d;
  `}
  color: #fff;
`

const TrackNumber = styled.span``

const TableRow = styled.tr`
  height: 38px;

  font-family: 'Source Sans Pro';
  font-style: normal;
  font-size: 16px;
  line-height: 20px;


  &:hover {
    ${props => props.hoverStyles}
  }
`

const TableCell = styled.td`
  ${props => props.width && `
    width: ${props.width}px;
  `}

  ${props => props.side && props.padding && `

    ${(props.side === 'left') ? `
      padding: 0 0 0 ${props.padding}px;
      text-align: left;
    ` : `
      padding: 0 ${props.padding}px 0 0;
      text-align: right;
    `}}
  `}

  ${props => props.separators && `
    border-bottom: 1px solid #4d4d4d;
  `}

  user-select: none;
  cursor: default;

  & > * {
    vertical-align: middle;
  }
`

class Table extends React.Component {
  static defaultProps = {
    separators: true
  }

  constructor (props) {
    super(props)

    this.state = {
      containerWidth: undefined,
      columnCount: 1,
      slicedColumns: [props.rows]
    }
  }

  onResize = async (containerWidth) => {
    await this.setState(prevState => ({
      containerWidth
    }))
    this.recalculateColumns()
  }

  componentDidMount () {
    // onResize gets called upon mount automatically
  }

  componentDidUpdate (prevProps) {
    if (this.props.rows != prevProps.rows) {
      this.recalculateColumns(true)
    }
  }

  recalculateColumns = async (force=false) => {
    const columnCount = Math.floor(this.state.containerWidth / totalMinWidthOfColumnTable)

    await this.setState(prevState => {
      if (columnCount !== prevState.columnCount || force) {
        // Something changed, we need to recalculate the array slices
        // force flag is for when the rows changed

        const contentsLength = this.props.rows.length
        const columnLength = Math.floor(contentsLength / columnCount)
        var remainder = (contentsLength % columnCount)

        var remainderUsedUp = 0
        var lastColumnSlicedUpTo = 0

        // Limit the number of columns to the number of rows if the number of rows is less than the number of columns
        if (contentsLength < columnCount)
          var overrideColumnCount = contentsLength

        const slicedColumns = [...Array(overrideColumnCount ? overrideColumnCount : columnCount)]
          .map( (column, i) => {
            const addAnyRemainder = (remainder > 0) ? 1 : 0
            const toReturn = this.props.rows.slice(lastColumnSlicedUpTo, (i+1)*(columnLength) + addAnyRemainder + remainderUsedUp)

            lastColumnSlicedUpTo = (i+1)*(columnLength) + addAnyRemainder + remainderUsedUp

            remainder--
            remainderUsedUp++
            if (remainder < 0) {
              remainder = 0
              remainderUsedUp--
            }

            return toReturn
          })

        return {
          columnCount,
          slicedColumns
        }
      }
    })
  }

  render () {
    return (
      <Wrap>
        {this.state.slicedColumns.map( (column, columnI) => (
          <ColumnTableWrap key={columnI}>
            <ColumnTable>
              <TableHead>
                <tr>
                  {this.props.headings.map( (heading, i) => <TableHeading key={i} {...this.props.layouts[i]} separators={this.props.separators}>{heading}</TableHeading>)}
                </tr>
              </TableHead>
              <tbody>
                {column.map( (row, i) => (
                  <TableRow key={row[this.props.rowKey]} hoverStyles={this.props.hoverStyles}>

                    {row.map( (cellContent, cellIndex) => (
                      <TableCell key={cellIndex} {...this.props.layouts[cellIndex]} separators={this.props.separators}>
                        {cellContent}
                      </TableCell>
                    ))}

                  </TableRow>
                ))}
              </tbody>
            </ColumnTable>
          </ColumnTableWrap>
        ))}
        <ReactResizeDetector handleWidth onResize={this.onResize} />
      </Wrap>
    )
  }
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Main/Table.js